{
  "name": "kns-core",
  "version": "0.13.28",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --prod --output-hashing all",
    "build-dev": "ng build --configuration dev --output-hashing all",
    "build-qa": "ng build --configuration qa --output-hashing all",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.5",
    "@angular/cdk": "^19.1.3",
    "@angular/common": "^19.1.5",
    "@angular/compiler": "^19.1.5",
    "@angular/core": "^19.1.5",
    "@angular/forms": "^19.1.5",
    "@angular/material": "^19.1.3",
    "@angular/material-moment-adapter": "^19.1.5",
    "@angular/platform-browser": "^19.1.5",
    "@angular/platform-browser-dynamic": "^19.1.5",
    "@angular/router": "^19.1.5",
    "@kns-jasfbg/feature-shipment": "3.1.10-beta.0",
    "@jas-fbg-sa/feature-agencies": "2.0.0-beta.1",
    "@jas-fbg-sa/feature-settlements": "1.0.0",
    "@jas-fbg-sa/feature-logistics": "2.0.0-beta.1",
    "@kns-jasfbg/users": "0.2.23-beta.0",
    "@kns-jasfbg/notifications": "0.3.13-beta.0",
    "@kns-jasfbg/kns-snackbar": "1.2.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@types/gsap": "^3.0.0",
    "@types/jquery": "^3.5.9",
    "angular-oauth2-oidc": "^19.0.0",
    "@fortawesome/angular-fontawesome": "^0.10.2",
    "@fortawesome/fontawesome-svg-core": "^1.2.35",
    "@fortawesome/free-solid-svg-icons": "^5.15.4",
    "bootstrap": "^5.1.3",
    "chart.js": "^4.4.9",
    "gsap": "^3.8.0",
    "jquery": "^3.6.0",
    "jwt-decode": "^3.1.2",
    "moment": "^2.29.1",
    "ngx-hotjar": "^11.0.0",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.6",
    "@angular/cli": "^19.1.6",
    "@angular/compiler-cli": "^19.1.5",
    "@types/jasmine": "~3.10.0",
    "@types/node": "^12.11.1",
    "codelyzer": "^6.0.0",
    "jasmine-core": "~4.0.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.3.16",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "5.6.3"
  }
}
